import { Link } from 'react-router-dom';
import { LogoIcon } from './Header';

export const Footer = () => {
  return (
    <div className="p-8 bg-cyan-800">
      <div className="flex flex-col md:flex-row gap-8 justify-between items-center w-full max-w-screen-xl mx-auto">
        <LogoIcon />
        <div className="flex gap-8 flex-col md:flex-row ">
          <div className="flex flex-col gap-1 text-sm text-white">
            <p className="font-bold">About</p>
            <Link to="/books">Explore</Link>
            <Link to="/login">Sign in</Link>
            <Link to="/register">Register</Link>
          </div>
          <div className="flex flex-col gap-1 text-sm text-white">
            <p className="font-bold">Contacts</p>
            <p>info@sellbooks.ai</p>
          </div>
          <div className="flex flex-col text-xs text-gray-200 align-end">
            <p>© SellBooks AI</p>
          </div>
        </div>
      </div>
    </div>
  );
};
